module.exports = __webpack_public_path__ + "img/2.c845001b.png";